import { Component, OnInit, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
//import * as AOS from 'aos';
import { LinkService } from '../../_services/langhfre.service';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { NavigationService } from 'src/app/_services/navigation.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-life-sciences-medicine-and-pharma',
  templateUrl: './life-sciences-medicine-and-pharma.component.html',
  styleUrls: ['./life-sciences-medicine-and-pharma.component.scss']
})
export class LifeSciencesMedicineAndPharmaComponent implements OnInit {
  
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private _renderer2: Renderer2, 
    @Inject(DOCUMENT) private _document: Document,
    public loadScript: LoadScriptService,
    public navigationService: NavigationService
  ) {
    
  }

  ngOnInit() {
    this.titleService.setTitle("Trinka Enterprise | Life Sciences, Medicine & Pharma");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka's powerful AI recognizes the subtleties and technical precision required in medical and scientific writing. Create critical documents efficiently." });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinka Enterprise | Life Sciences, Medicine & Pharma" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka's powerful AI recognizes the subtleties and technical precision required in medical and scientific writing. Create critical documents efficiently." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/enterprise/life-sciences-medicine-and-pharma' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/enterprise/medical.webp' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka Enterprise | Life Sciences, Medicine & Pharma' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka's powerful AI recognizes the subtleties and technical precision required in medical and scientific writing. Create critical documents efficiently." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/enterprise/medical.webp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/life-sciences-medicine-and-pharma' });

    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
    {"@context":"https://schema.org/","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Trinka AI","item":"https://www.trinka.ai/"},{"@type":"ListItem","position":2,"name":"Enterprise","item":"https://www.trinka.ai/enterprise"},{"@type":"ListItem","position":3,"name":"Life Sciences Medicine and Pharma","item":"https://www.trinka.ai/enterprise/life-sciences-medicine-and-pharma"}]}
    `;

    this._renderer2.appendChild(this._document.head, script);

    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

  globalSliderData: any[] = [
    { "imgSrc": "/assets/images/client_logos/j-j.png", "altText": "johnsons" },
    { "imgSrc": "/assets/images/client_logos/cigna.png", "altText": "cigna" },
    { "imgSrc": "/assets/images/client_logos/novartis.png", "altText": "novartis" },
    { "imgSrc": "/assets/images/client_logos/merck.png", "altText": "merck" },
    { "imgSrc": "/assets/images/client_logos/abbvie.png", "altText": "abbvie" },
    { "imgSrc": "/assets/images/client_logos/amgen.png", "altText": "amgen" },
    { "imgSrc": "/assets/images/client_logos/biogen.png", "altText": "biogen" },
    { "imgSrc": "/assets/images/client_logos/who.png", "altText": "who" },
    { "imgSrc": "/assets/images/client_logos/accelera.png", "altText": "accelera" },
    { "imgSrc": "/assets/images/client_logos/pfizer.png", "altText": "pfizer" }
  ];

}
